import FloatingVue from 'floating-vue';

import confirmar from '@/directives/confirmar';
import campoRequerido from '@/directives/campo_requerido';
import submitOnChange from '@/directives/submit-on-change';

import TurbolinksCifraAdapter from '@/libs/TurbolinksCifraAdapter';
import toast from '../../libs/cifra/toast';
import { configuredTimeZone } from '../../libs/dates';

import AdminVuePlugin from './admin/VuePlugin';
import Agenda from './Agenda.vue';
import CifraComponentsPlugin from '../../components/cifra/VuePlugin';
import CuadernoAsistencia from './cuadernos/CuadernoAsistencia.vue';
import CuadernoEvaluacionPreferencias from './cuadernos/evaluaciones/PreferenciasView.vue';
import AsistenciaPasarLista from './asistencia/AsistenciaPasarLista.vue';
import GeVuePlugin from './gestion_economica/VuePlugin';
import GuardiasVuePlugin from './guardias/VuePlugin';
import Modelo182VuePlugin from './modelo182/VuePlugin';
import Modelo233VuePlugin from './modelo233/VuePlugin';
import RecursosVuePlugin from './recursos/VuePlugin';
import TiendasPlugin from './tiendas/VuePlugin';
import TransporteVuePlugin from './transporte/VuePlugin';
import CalificacionesVuePlugin from './calificaciones/VuePlugin';
import LomloeVuePlugin from './lomloe/VuePlugin';

import 'floating-vue/dist/style.css';
import 'air-datepicker/air-datepicker.css';
import 'glightbox/dist/css/glightbox.css';

// Tooltips más rápidos mostrándose
FloatingVue.options.themes.tooltip.delay = {
  show: 100,
  hide: 0,
};
// Alejamos un poco el tooltip para que no parpadee con el ratón
FloatingVue.options.themes.tooltip.distance = 8;

/* global I18n, Cifra */
export default {
  install: (app, _options) => {
    // Ponemos accesibles todos los componentes que se cargan en cifra
    app.provide('I18n', I18n);
    app.provide('toast', toast);
    app.provide('CifraGlobal', Cifra);

    app.config.globalProperties.$timeZone = configuredTimeZone();
    app.config.globalProperties.$I18n = I18n;
    app.config.globalProperties.$t = I18n.t;
    app.config.globalProperties.$Cifra = Cifra;
    app.config.globalProperties.$toast = toast;

    app.use(TurbolinksCifraAdapter)
      .use(FloatingVue)
      .use(CifraComponentsPlugin)
      .use(AdminVuePlugin)
      .use(GeVuePlugin)
      .use(GuardiasVuePlugin)
      .use(Modelo182VuePlugin)
      .use(Modelo233VuePlugin)
      .use(RecursosVuePlugin)
      .use(TiendasPlugin)
      .use(TransporteVuePlugin)
      .use(CalificacionesVuePlugin)
      .use(LomloeVuePlugin);

    app
      // eslint-disable-next-line vue/multi-word-component-names
      .component('Agenda', Agenda)
      .component('CuadernoAsistencia', CuadernoAsistencia)
      .component('CuadernoEvaluacionPreferencias', CuadernoEvaluacionPreferencias)
      .component('AsistenciaPasarLista', AsistenciaPasarLista);

    app.directive('confirmar', confirmar);
    app.directive('campoRequerido', campoRequerido);
    app.directive('submitOnChange', submitOnChange);
  },
};
